var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "login" }, [
    _c(
      "div",
      {
        staticClass:
          "login-cntr d-flex align-items-center justify-center flex-wrap baselayout-bar",
      },
      [
        _c(
          "div",
          {
            staticClass: "m-auto login-box d-flex align-items-center flex-wrap",
          },
          [
            _c(
              "div",
              { staticClass: "left align-items-center d-flex flex-wrap" },
              [
                _c(
                  "router-link",
                  { staticClass: "brand", attrs: { to: "/" } },
                  [
                    _c("img", {
                      staticClass: "brand-img",
                      attrs: {
                        src: require("../../assets/logo.png"),
                        alt: "logo image",
                      },
                    }),
                  ]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "right" },
              [
                _c("transition", { attrs: { name: "fade" } }, [
                  _vm.show === false
                    ? _c("div", [
                        _c("h1", { staticClass: "text-center" }, [
                          _vm._v(_vm._s(_vm.$t("lang.content.welcome"))),
                        ]),
                        _c(
                          "form",
                          {
                            attrs: { novalidate: "" },
                            on: {
                              submit: function ($event) {
                                $event.preventDefault()
                                return _vm.onSubmit.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _vm.msjErrorlogin.length != 0
                              ? _c("b-form-invalid-feedback", [
                                  _vm._v(_vm._s(_vm.msjErrorlogin)),
                                ])
                              : _vm._e(),
                            _c(
                              "div",
                              {
                                staticClass: "form-group",
                                class: {
                                  "form-group--error": _vm.$v.usuario.$error,
                                },
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model.trim",
                                      value: _vm.usuario,
                                      expression: "usuario",
                                      modifiers: { trim: true },
                                    },
                                  ],
                                  staticClass:
                                    "form__input form-control form-control__usuario",
                                  attrs: {
                                    type: "text",
                                    placeholder: _vm.$t("lang.content.user"),
                                  },
                                  domProps: { value: _vm.usuario },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.usuario = $event.target.value.trim()
                                    },
                                    blur: function ($event) {
                                      return _vm.$forceUpdate()
                                    },
                                  },
                                }),
                                _vm.$v.usuario.$error
                                  ? _c(
                                      "div",
                                      { staticClass: "invalid-feedback" },
                                      [
                                        !_vm.$v.usuario.required
                                          ? _c(
                                              "div",
                                              { staticClass: "error" },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "lang.errors.user_required"
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        !_vm.$v.usuario.email
                                          ? _c(
                                              "div",
                                              { staticClass: "error" },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "lang.errors.user_emailWrong"
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "form-group",
                                class: {
                                  "form-group--error": _vm.$v.password.$error,
                                },
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model.trim",
                                      value: _vm.password,
                                      expression: "password",
                                      modifiers: { trim: true },
                                    },
                                  ],
                                  staticClass:
                                    "form-control form-control__password",
                                  attrs: {
                                    type: "password",
                                    placeholder: _vm.$t(
                                      "lang.content.password"
                                    ),
                                  },
                                  domProps: { value: _vm.password },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.password = $event.target.value.trim()
                                    },
                                    blur: function ($event) {
                                      return _vm.$forceUpdate()
                                    },
                                  },
                                }),
                                _vm.$v.password.$error
                                  ? _c(
                                      "div",
                                      { staticClass: "invalid-feedback" },
                                      [
                                        !_vm.$v.password.required
                                          ? _c(
                                              "div",
                                              { staticClass: "error" },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "lang.errors.password_require"
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        !_vm.$v.password.minLength
                                          ? _c(
                                              "div",
                                              { staticClass: "error" },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "lang.errors.password_minLength"
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "link" },
                              [
                                _c(
                                  "b-link",
                                  {
                                    staticClass: "text-link",
                                    attrs: { href: "#" },
                                    on: { click: _vm.fadeMe },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("lang.content.forgot_password")
                                      )
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c("input", {
                              attrs: {
                                type: "checkbox",
                                name: "recuérdame",
                                value: "accepted",
                              },
                            }),
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("lang.content.remember_me")) +
                                " "
                            ),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-outline-info",
                                attrs: { type: "submit" },
                                on: {
                                  click: function ($event) {
                                    return _vm.$gtm.push({
                                      event: "login-event",
                                    })
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("lang.buttons.login")) +
                                    " "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                ]),
                _c("transition", { attrs: { name: "fade" } }, [
                  _vm.show
                    ? _c(
                        "div",
                        [
                          _c("h1", [
                            _vm._v(
                              _vm._s(_vm.$t("lang.content.forgot_password"))
                            ),
                          ]),
                          _c("p"),
                          _c(
                            "b-form",
                            { on: { submit: _vm.onSubmit } },
                            [
                              _c("b-form-valid-feedback", [
                                _vm._v(
                                  _vm._s(_vm.$t("lang.content.email_remember"))
                                ),
                              ]),
                              _c(
                                "b-form-group",
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      type: "email",
                                      placeholder: _vm.$t("lang.content.user"),
                                      required: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "b-button",
                                {
                                  attrs: {
                                    type: "submit",
                                    variant: "outline-info",
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("lang.buttons.send")))]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
              ],
              1
            ),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }